import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Button,
  HorizontalStack,
  Icon,
  KCol,
  KPagination,
  KRow,
  KTab,
  KTabItem,
  KTable,
  KTableColumn,
  KTableRow,
  Label,
  TextInput,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { BasketReports_ScreenBase } from "./basketreports-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class BasketReports_Screen extends BasketReports_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin
          spinning={
            this.state.spinnerCount > 0 ||
            (!!this.context?.callCallbackFunction &&
              !this.context?.isMasterPageInitLoaded &&
              !this.state.isPageInitLoaded)
          }
        >
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              component={false}
              initialValues={{
                basketreports_622167_value: undefined,
                basketreports_365482_value: undefined,
                basketreports_127883_value: undefined,
                basketreports_41021_value: undefined,
                basketreports_928556_value: undefined,
                basketreports_873968_value: undefined,
              }}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <>
                <div
                  key="-1"
                  id="basketreports_body"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(244, 244, 244, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      display: "block",
                      overflow: "auto",
                      minHeight:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                      maxHeight:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                      height:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                    } as any
                  }
                >
                  <KRow
                    key="584761"
                    id="584761"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="103314"
                      id="103314"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <Form.Item
                        className="kFormItem"
                        name="basketreports_622167_value"
                        noStyle
                      >
                        <KTab
                          key="622167"
                          id="622167"
                          type="line"
                          size="default"
                          tabPosition="top"
                          selectedTabColor="#0078FF"
                          justifiedTabTitles={false}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KTabItem
                            key={602534}
                            id="602534"
                            tab={ReactSystemFunctions.translate(
                              this.ml,
                              602534,
                              "tab",
                              this.defaultML
                            )}
                            forceRender={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                backgroundColor: "rgba(255, 255, 255, 1)",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                                backgroundPosition: "left",
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KRow
                              key="825933"
                              id="825933"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KCol
                                key="490289"
                                id="490289"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KRow
                                  key="253525"
                                  id="253525"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="260778"
                                    id="260778"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <VerticalStack
                                      key="675530"
                                      id="675530"
                                      direction="vertical"
                                      size={1}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="307658"
                                        id="307658"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          307658,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                      <Form.Item
                                        className="kFormItem"
                                        name="basketreports_365482_value"
                                      >
                                        <TextInput
                                          key="365482"
                                          id="365482"
                                          kuikaRef={
                                            this
                                              .basketreports_365482_value_kuikaTextInputRef
                                          }
                                          placeholder={ReactSystemFunctions.translate(
                                            this.ml,
                                            365482,
                                            "placeholder",
                                            this.defaultML
                                          )}
                                          allowClear={false}
                                          bordered={true}
                                          disabled={false}
                                          type="text"
                                          iconColor="rgba(0, 0, 0, 1)"
                                          formatter="None"
                                          isCharOnly={false}
                                          autoComplete={true}
                                          inputMode="all"
                                          speechToText={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderTopWidth: 1,
                                              borderRightWidth: 1,
                                              borderBottomWidth: 1,
                                              borderLeftWidth: 1,
                                              borderColor:
                                                "rgba(218, 218, 218, 1)",
                                              borderStyle: "solid",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "block",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></TextInput>
                                      </Form.Item>
                                      <Label
                                        key="402397"
                                        id="402397"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          402397,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                      <Form.Item
                                        className="kFormItem"
                                        name="basketreports_127883_value"
                                      >
                                        <TextInput
                                          key="127883"
                                          id="127883"
                                          kuikaRef={
                                            this
                                              .basketreports_127883_value_kuikaTextInputRef
                                          }
                                          placeholder={ReactSystemFunctions.translate(
                                            this.ml,
                                            127883,
                                            "placeholder",
                                            this.defaultML
                                          )}
                                          allowClear={false}
                                          bordered={true}
                                          disabled={false}
                                          type="text"
                                          iconColor="rgba(0, 0, 0, 1)"
                                          formatter="None"
                                          isCharOnly={false}
                                          autoComplete={true}
                                          inputMode="all"
                                          speechToText={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderTopWidth: 1,
                                              borderRightWidth: 1,
                                              borderBottomWidth: 1,
                                              borderLeftWidth: 1,
                                              borderColor:
                                                "rgba(218, 218, 218, 1)",
                                              borderStyle: "solid",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "block",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></TextInput>
                                      </Form.Item>
                                    </VerticalStack>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="935571"
                                  id="935571"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="387315"
                                    id="387315"
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    xxl={12}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <Button
                                      key="961258"
                                      id="961258"
                                      onClick={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.BasketReportsComponent_961258_onClick();
                                      }}
                                      showCursorPointer
                                      label={ReactSystemFunctions.translate(
                                        this.ml,
                                        961258,
                                        "label",
                                        this.defaultML
                                      )}
                                      size="middle"
                                      loading={false}
                                      ghost={false}
                                      block={false}
                                      htmlType="button"
                                      iconPosition="left"
                                      danger={false}
                                      iconLibrary="material"
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 2,
                                          borderRightWidth: 2,
                                          borderBottomWidth: 2,
                                          borderLeftWidth: 2,
                                          borderColor: "rgba(0, 0, 0, 0.2)",
                                          borderStyle: "solid",
                                          backgroundColor:
                                            "rgba(244, 244, 244, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 16,
                                          paddingBottom: 8,
                                          paddingLeft: 16,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "16px",
                                          color: "rgba(0, 0, 0, 1)",
                                        } as any
                                      }
                                    ></Button>
                                  </KCol>
                                  <KCol
                                    key="298552"
                                    id="298552"
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    xxl={12}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <Button
                                      key="444724"
                                      id="444724"
                                      onClick={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.BasketReportsComponent_444724_onClick();
                                      }}
                                      showCursorPointer
                                      label={ReactSystemFunctions.translate(
                                        this.ml,
                                        444724,
                                        "label",
                                        this.defaultML
                                      )}
                                      size="middle"
                                      loading={false}
                                      ghost={false}
                                      block={false}
                                      htmlType="button"
                                      iconPosition="left"
                                      danger={false}
                                      iconLibrary="material"
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 2,
                                          borderRightWidth: 2,
                                          borderBottomWidth: 2,
                                          borderLeftWidth: 2,
                                          borderColor: "transparent",
                                          borderStyle: "solid",
                                          backgroundColor: "rgba(0, 0, 0, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 16,
                                          paddingBottom: 8,
                                          paddingLeft: 16,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "16px",
                                          color: "rgba(255, 255, 255, 1)",
                                        } as any
                                      }
                                    ></Button>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="30853"
                                  id="30853"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="292441"
                                    id="292441"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KTable
                                      key="287569"
                                      id="287569"
                                      kuikaRef={
                                        this
                                          .basketreports_287569_value_kuikaTableRef
                                      }
                                      form={this.props.form}
                                      dataSource={this.state.ActiveBasket}
                                      size="middle"
                                      bordered={true}
                                      loading={false}
                                      rowKey="id"
                                      transformedOnMobileResolution={false}
                                      hideHeaderOnMobileResolution={false}
                                      showHeader={true}
                                      fixedHeader={false}
                                      tableWidthMode="fit"
                                      editable={false}
                                      editableAlwaysActive={false}
                                      insertRowActive={false}
                                      insertRowPosition="top"
                                      globalSearch={false}
                                      searchable={false}
                                      shouldSearchOnChange={true}
                                      searchDelay={200}
                                      sorter={false}
                                      filtering={false}
                                      resizableColumns={false}
                                      pagination={false}
                                      pageSize={10}
                                      showSizeChanger={false}
                                      paginationSelectedTextColor="#246eff"
                                      paginationUnselectedTextColor="#000"
                                      columnChooser={false}
                                      striped={false}
                                      stripedColor="#F5F7FA"
                                      rowHoverBgColor="#fafafa"
                                      showRowNumbers={false}
                                      showNoDataFound={true}
                                      nodatafoundmessage={ReactSystemFunctions.translate(
                                        this.ml,
                                        287569,
                                        "nodatafoundmessage",
                                        this.defaultML
                                      )}
                                      multiSelect={false}
                                      multiSelectScope="page"
                                      export={false}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KTableRow
                                        key="433902"
                                        id="433902"
                                        hoverFontColor="red"
                                        hoverBgColor="#F5F5F5"
                                        style={
                                          {
                                            borderTopWidth: 1,
                                            borderRightWidth: 1,
                                            borderBottomWidth: 1,
                                            borderLeftWidth: 1,
                                            borderColor:
                                              "rgba(218, 218, 218, 1)",
                                            borderStyle: "solid",
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KTableColumn
                                          key="546124"
                                          id="546124"
                                          title={ReactSystemFunctions.translate(
                                            this.ml,
                                            546124,
                                            "title",
                                            this.defaultML
                                          )}
                                          alwaysVisibleOnMobileResolution={
                                            false
                                          }
                                          hideFiltering={false}
                                          hideSorting={false}
                                          hideSearch={false}
                                          footerOptions="none"
                                          footerFontSize={14}
                                          footerFontColor="rgb(68, 68, 68)"
                                          excludeFromExport={false}
                                          footerFontWeight="Regular"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="192392"
                                            id="192392"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="704013"
                                              id="704013"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Icon
                                                key="875174"
                                                id="875174"
                                                visibility={
                                                  this.state
                                                    .isCompbasketreports_875174AuthorizationVisible
                                                }
                                                visibilityByAuthorization={
                                                  this.state
                                                    .isCompbasketreports_875174AuthorizationVisible
                                                }
                                                iconName="delete_forever"
                                                iconLibrary="material"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "24px",
                                                    color:
                                                      "rgba(225, 60, 57, 1)",
                                                    letterSpacing: "1px",
                                                  } as any
                                                }
                                              ></Icon>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="258000"
                                            id="258000"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="103635"
                                              id="103635"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <VerticalStack
                                                key="429214"
                                                id="429214"
                                                direction="vertical"
                                                size={1}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "15px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <HorizontalStack
                                                  key="91168"
                                                  id="91168"
                                                  direction="horizontal"
                                                  size={2}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="943973"
                                                    id="943973"
                                                    iconName="brightness_1"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(231, 96, 51, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                  <Label
                                                    key="99155"
                                                    id="99155"
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      99155,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(231, 96, 51, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="545305"
                                                    id="545305"
                                                    value="[datafield:createdAt]"
                                                    formatter="date"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 600,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(155, 155, 155, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                                <Label
                                                  key="894316"
                                                  id="894316"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    894316,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <HorizontalStack
                                                  key="404256"
                                                  id="404256"
                                                  direction="horizontal"
                                                  size={12}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="25786"
                                                    id="25786"
                                                    value="[datafield:curAccCode]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(155, 155, 155, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="903685"
                                                    id="903685"
                                                    value="[datafield:customerName]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "15px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                                <Label
                                                  key="51611"
                                                  id="51611"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    51611,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <HorizontalStack
                                                  key="539379"
                                                  id="539379"
                                                  direction="horizontal"
                                                  size={12}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="48222"
                                                    id="48222"
                                                    value="[datafield:salesPersonCode]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(155, 155, 155, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="49054"
                                                    id="49054"
                                                    value="[datafield:salesPersonName]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "15px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                              </VerticalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="798020"
                                            id="798020"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="787303"
                                              id="787303"
                                              xs={18}
                                              sm={18}
                                              md={18}
                                              lg={18}
                                              xl={18}
                                              xxl={18}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 0,
                                                  paddingLeft: 8,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-center",
                                                } as any
                                              }
                                            >
                                              <VerticalStack
                                                key="884705"
                                                id="884705"
                                                direction="vertical"
                                                size={1}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "15px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="859377"
                                                  id="859377"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    859377,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="864914"
                                                  id="864914"
                                                  value="[datafield:totalQuantity]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </VerticalStack>
                                            </KCol>
                                            <KCol
                                              key="587250"
                                              id="587250"
                                              xs={6}
                                              sm={6}
                                              md={6}
                                              lg={6}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Icon
                                                key="794632"
                                                id="794632"
                                                onClick={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.BasketReportsComponent_794632_onClick();
                                                }}
                                                showCursorPointer
                                                iconName="arrow_forward"
                                                iconLibrary="material"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(0, 0, 0, 1)",
                                                    borderStyle: "solid",
                                                    paddingTop: 4,
                                                    paddingRight: 4,
                                                    paddingBottom: 4,
                                                    paddingLeft: 4,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "24px",
                                                    color: "rgba(0, 0, 0, 1)",
                                                    letterSpacing: "1px",
                                                  } as any
                                                }
                                              ></Icon>
                                            </KCol>
                                          </KRow>
                                        </KTableColumn>
                                      </KTableRow>
                                    </KTable>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="516664"
                                  id="516664"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="425996"
                                    id="425996"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KPagination
                                      key="377233"
                                      id="377233"
                                      onChange={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.BasketReportsComponent_377233_onChange();
                                      }}
                                      kuikaRef={
                                        this
                                          .basketreports_377233_value_kuikaPaginationRef
                                      }
                                      total={
                                        this.state.ActiveBasket?.at?.(0)
                                          ?.totalRowCount ?? undefined
                                      }
                                      pageSize={10}
                                      defaultCurrent={1}
                                      current={1}
                                      defaultPageSize={10}
                                      disabled={false}
                                      hideOnSinglePage={true}
                                      showLessItems={false}
                                      showQuickJumper={false}
                                      showSizeChanger={false}
                                      showFirstPageButton={false}
                                      showLastPageButton={false}
                                      showNumbers={true}
                                      showText={false}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-right",
                                        } as any
                                      }
                                    ></KPagination>
                                  </KCol>
                                </KRow>
                              </KCol>
                            </KRow>
                          </KTabItem>
                          <KTabItem
                            key={687282}
                            id="687282"
                            tab={ReactSystemFunctions.translate(
                              this.ml,
                              687282,
                              "tab",
                              this.defaultML
                            )}
                            forceRender={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                backgroundColor: "rgba(255, 255, 255, 1)",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                                backgroundPosition: "left",
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 400,
                                fontSize: "15px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KRow
                              key="888988"
                              id="888988"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                } as any
                              }
                            >
                              <KCol
                                key="481961"
                                id="481961"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                  } as any
                                }
                              >
                                <KRow
                                  key="955371"
                                  id="955371"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="308905"
                                    id="308905"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <VerticalStack
                                      key="785152"
                                      id="785152"
                                      direction="vertical"
                                      size={1}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <Label
                                        key="453444"
                                        id="453444"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          453444,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                      <Form.Item
                                        className="kFormItem"
                                        name="basketreports_41021_value"
                                      >
                                        <TextInput
                                          key="41021"
                                          id="41021"
                                          kuikaRef={
                                            this
                                              .basketreports_41021_value_kuikaTextInputRef
                                          }
                                          placeholder={ReactSystemFunctions.translate(
                                            this.ml,
                                            41021,
                                            "placeholder",
                                            this.defaultML
                                          )}
                                          allowClear={false}
                                          bordered={true}
                                          disabled={false}
                                          type="text"
                                          iconColor="rgba(0, 0, 0, 1)"
                                          formatter="None"
                                          isCharOnly={false}
                                          autoComplete={true}
                                          inputMode="all"
                                          speechToText={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderTopWidth: 1,
                                              borderRightWidth: 1,
                                              borderBottomWidth: 1,
                                              borderLeftWidth: 1,
                                              borderColor:
                                                "rgba(218, 218, 218, 1)",
                                              borderStyle: "solid",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "block",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></TextInput>
                                      </Form.Item>
                                      <Label
                                        key="130906"
                                        id="130906"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          130906,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                      <Form.Item
                                        className="kFormItem"
                                        name="basketreports_928556_value"
                                      >
                                        <TextInput
                                          key="928556"
                                          id="928556"
                                          kuikaRef={
                                            this
                                              .basketreports_928556_value_kuikaTextInputRef
                                          }
                                          placeholder={ReactSystemFunctions.translate(
                                            this.ml,
                                            928556,
                                            "placeholder",
                                            this.defaultML
                                          )}
                                          allowClear={false}
                                          bordered={true}
                                          disabled={false}
                                          type="text"
                                          iconColor="rgba(0, 0, 0, 1)"
                                          formatter="None"
                                          isCharOnly={false}
                                          autoComplete={true}
                                          inputMode="all"
                                          speechToText={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderTopWidth: 1,
                                              borderRightWidth: 1,
                                              borderBottomWidth: 1,
                                              borderLeftWidth: 1,
                                              borderColor:
                                                "rgba(218, 218, 218, 1)",
                                              borderStyle: "solid",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "block",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></TextInput>
                                      </Form.Item>
                                      <Label
                                        key="18289"
                                        id="18289"
                                        value={ReactSystemFunctions.translate(
                                          this.ml,
                                          18289,
                                          "value",
                                          this.defaultML
                                        )}
                                        writingMode="horizontal"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            display: "inline",
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      ></Label>
                                      <Form.Item
                                        className="kFormItem"
                                        name="basketreports_873968_value"
                                      >
                                        <TextInput
                                          key="873968"
                                          id="873968"
                                          kuikaRef={
                                            this
                                              .basketreports_873968_value_kuikaTextInputRef
                                          }
                                          placeholder={ReactSystemFunctions.translate(
                                            this.ml,
                                            873968,
                                            "placeholder",
                                            this.defaultML
                                          )}
                                          allowClear={false}
                                          bordered={true}
                                          disabled={false}
                                          type="text"
                                          iconColor="rgba(0, 0, 0, 1)"
                                          formatter="None"
                                          isCharOnly={false}
                                          autoComplete={true}
                                          inputMode="all"
                                          speechToText={false}
                                          style={
                                            {
                                              borderTopLeftRadius: 8,
                                              borderTopRightRadius: 8,
                                              borderBottomRightRadius: 8,
                                              borderBottomLeftRadius: 8,
                                              borderTopWidth: 1,
                                              borderRightWidth: 1,
                                              borderBottomWidth: 1,
                                              borderLeftWidth: 1,
                                              borderColor:
                                                "rgba(218, 218, 218, 1)",
                                              borderStyle: "solid",
                                              backgroundColor:
                                                "rgba(255, 255, 255, 1)",
                                              backgroundRepeat: "no-repeat",
                                              backgroundSize: "contain",
                                              backgroundPosition: "left",
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "block",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></TextInput>
                                      </Form.Item>
                                    </VerticalStack>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="271949"
                                  id="271949"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="992878"
                                    id="992878"
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    xxl={12}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <Button
                                      key="24577"
                                      id="24577"
                                      onClick={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.BasketReportsComponent_24577_onClick();
                                      }}
                                      showCursorPointer
                                      label={ReactSystemFunctions.translate(
                                        this.ml,
                                        24577,
                                        "label",
                                        this.defaultML
                                      )}
                                      size="middle"
                                      loading={false}
                                      ghost={false}
                                      block={false}
                                      htmlType="button"
                                      iconPosition="left"
                                      danger={false}
                                      iconLibrary="material"
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 2,
                                          borderRightWidth: 2,
                                          borderBottomWidth: 2,
                                          borderLeftWidth: 2,
                                          borderColor: "rgba(0, 0, 0, 0.2)",
                                          borderStyle: "solid",
                                          backgroundColor:
                                            "rgba(244, 244, 244, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 16,
                                          paddingBottom: 8,
                                          paddingLeft: 16,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "16px",
                                          color: "rgba(0, 0, 0, 1)",
                                        } as any
                                      }
                                    ></Button>
                                  </KCol>
                                  <KCol
                                    key="736153"
                                    id="736153"
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    xxl={12}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <Button
                                      key="24124"
                                      id="24124"
                                      onClick={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.BasketReportsComponent_24124_onClick();
                                      }}
                                      showCursorPointer
                                      label={ReactSystemFunctions.translate(
                                        this.ml,
                                        24124,
                                        "label",
                                        this.defaultML
                                      )}
                                      size="middle"
                                      loading={false}
                                      ghost={false}
                                      block={false}
                                      htmlType="button"
                                      iconPosition="left"
                                      danger={false}
                                      iconLibrary="material"
                                      style={
                                        {
                                          borderTopLeftRadius: 8,
                                          borderTopRightRadius: 8,
                                          borderBottomRightRadius: 8,
                                          borderBottomLeftRadius: 8,
                                          borderTopWidth: 2,
                                          borderRightWidth: 2,
                                          borderBottomWidth: 2,
                                          borderLeftWidth: 2,
                                          borderColor: "transparent",
                                          borderStyle: "solid",
                                          backgroundColor: "rgba(0, 0, 0, 1)",
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "contain",
                                          backgroundPosition: "left",
                                          paddingTop: 8,
                                          paddingRight: 16,
                                          paddingBottom: 8,
                                          paddingLeft: 16,
                                          alignItems: "center",
                                          textAlign: "-webkit-center",
                                          display: "block",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "16px",
                                          color: "rgba(255, 255, 255, 1)",
                                        } as any
                                      }
                                    ></Button>
                                  </KCol>
                                </KRow>
                                <KRow
                                  key="858589"
                                  id="858589"
                                  align="top"
                                  justify="start"
                                  horizontalGutter={0}
                                  verticalGutter={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 8,
                                      paddingRight: 8,
                                      paddingBottom: 8,
                                      paddingLeft: 8,
                                      alignItems: "flex-start",
                                      textAlign: "-webkit-left",
                                    } as any
                                  }
                                >
                                  <KCol
                                    key="928000"
                                    id="928000"
                                    xs={24}
                                    sm={24}
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    order={0}
                                    pull={0}
                                    push={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 8,
                                        paddingRight: 8,
                                        paddingBottom: 8,
                                        paddingLeft: 8,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                      } as any
                                    }
                                  >
                                    <KTable
                                      key="599097"
                                      id="599097"
                                      kuikaRef={
                                        this
                                          .basketreports_599097_value_kuikaTableRef
                                      }
                                      form={this.props.form}
                                      dataSource={this.state.CompletedBasket}
                                      size="middle"
                                      bordered={true}
                                      loading={false}
                                      rowKey="id"
                                      transformedOnMobileResolution={false}
                                      hideHeaderOnMobileResolution={false}
                                      showHeader={true}
                                      fixedHeader={false}
                                      tableWidthMode="fit"
                                      editable={false}
                                      editableAlwaysActive={false}
                                      insertRowActive={false}
                                      insertRowPosition="top"
                                      globalSearch={false}
                                      searchable={false}
                                      shouldSearchOnChange={true}
                                      searchDelay={200}
                                      sorter={false}
                                      filtering={false}
                                      resizableColumns={false}
                                      pagination={false}
                                      pageSize={10}
                                      showSizeChanger={false}
                                      paginationSelectedTextColor="#246eff"
                                      paginationUnselectedTextColor="#000"
                                      columnChooser={false}
                                      striped={false}
                                      stripedColor="#F5F7FA"
                                      rowHoverBgColor="#fafafa"
                                      showRowNumbers={false}
                                      showNoDataFound={true}
                                      nodatafoundmessage={ReactSystemFunctions.translate(
                                        this.ml,
                                        599097,
                                        "nodatafoundmessage",
                                        this.defaultML
                                      )}
                                      multiSelect={false}
                                      multiSelectScope="page"
                                      export={false}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KTableRow
                                        key="728690"
                                        id="728690"
                                        hoverFontColor="red"
                                        hoverBgColor="#F5F5F5"
                                        style={
                                          {
                                            borderTopWidth: 1,
                                            borderRightWidth: 1,
                                            borderBottomWidth: 1,
                                            borderLeftWidth: 1,
                                            borderColor:
                                              "rgba(218, 218, 218, 1)",
                                            borderStyle: "solid",
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KTableColumn
                                          key="931769"
                                          id="931769"
                                          title={ReactSystemFunctions.translate(
                                            this.ml,
                                            931769,
                                            "title",
                                            this.defaultML
                                          )}
                                          alwaysVisibleOnMobileResolution={
                                            false
                                          }
                                          hideFiltering={false}
                                          hideSorting={false}
                                          hideSearch={false}
                                          footerOptions="none"
                                          footerFontSize={14}
                                          footerFontColor="rgb(68, 68, 68)"
                                          excludeFromExport={false}
                                          footerFontWeight="Regular"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 8,
                                              paddingRight: 8,
                                              paddingBottom: 8,
                                              paddingLeft: 8,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <KRow
                                            key="848998"
                                            id="848998"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="848108"
                                              id="848108"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Icon
                                                key="852280"
                                                id="852280"
                                                visibility={
                                                  this.state
                                                    .isComp852280Visible ==
                                                    "hidden" ||
                                                  this.state
                                                    .isCompbasketreports_852280AuthorizationVisible ==
                                                    "hidden"
                                                    ? "hidden"
                                                    : "visible"
                                                }
                                                visibilityByAuthorization={
                                                  this.state
                                                    .isCompbasketreports_852280AuthorizationVisible ==
                                                  "hidden"
                                                    ? "hidden"
                                                    : "visible"
                                                }
                                                visibilityCondition={(
                                                  rowData: object
                                                ) =>
                                                  ReactSystemFunctions.isNotEqualTo(
                                                    rowData.statusCode,
                                                    "COMPLETED"
                                                  )
                                                }
                                                iconLibrary="material"
                                                iconName="delete_forever"
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    alignItems: "center",
                                                    textAlign: "-webkit-left",
                                                    display: "inline",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "24px",
                                                    color:
                                                      "rgba(225, 60, 57, 1)",
                                                    letterSpacing: "1px",
                                                  } as any
                                                }
                                              ></Icon>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="484217"
                                            id="484217"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 8,
                                                paddingRight: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 8,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="157666"
                                              id="157666"
                                              xs={24}
                                              sm={24}
                                              md={24}
                                              lg={24}
                                              xl={24}
                                              xxl={24}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                  alignItems: "flex-start",
                                                  textAlign: "-webkit-left",
                                                } as any
                                              }
                                            >
                                              <VerticalStack
                                                key="145829"
                                                id="145829"
                                                direction="vertical"
                                                size={1}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "15px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <HorizontalStack
                                                  key="86212"
                                                  id="86212"
                                                  direction="horizontal"
                                                  size={2}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Icon
                                                    key="659108"
                                                    id="659108"
                                                    visibility={
                                                      this.state
                                                        .isComp659108Visible
                                                    }
                                                    visibilityCondition={(
                                                      rowData: object
                                                    ) =>
                                                      ReactSystemFunctions.isEqualTo(
                                                        rowData.isCompleted,
                                                        "0"
                                                      )
                                                    }
                                                    iconName="brightness_1"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(225, 60, 57, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                  <Icon
                                                    key="939256"
                                                    id="939256"
                                                    visibility={
                                                      this.state
                                                        .isComp939256Visible
                                                    }
                                                    visibilityCondition={(
                                                      rowData: object
                                                    ) =>
                                                      ReactSystemFunctions.isEqualTo(
                                                        rowData.isCompleted,
                                                        "1"
                                                      )
                                                    }
                                                    iconName="brightness_1"
                                                    iconLibrary="material"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(114, 194, 64, 1)",
                                                        letterSpacing: "1px",
                                                      } as any
                                                    }
                                                  ></Icon>
                                                  <Label
                                                    key="605612"
                                                    id="605612"
                                                    visibility={
                                                      this.state
                                                        .isComp605612Visible
                                                    }
                                                    visibilityCondition={(
                                                      rowData: object
                                                    ) =>
                                                      ReactSystemFunctions.isEqualTo(
                                                        rowData.isCompleted,
                                                        "0"
                                                      )
                                                    }
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      605612,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(225, 60, 57, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="460956"
                                                    id="460956"
                                                    visibility={
                                                      this.state
                                                        .isComp460956Visible
                                                    }
                                                    visibilityCondition={(
                                                      rowData: object
                                                    ) =>
                                                      ReactSystemFunctions.isEqualTo(
                                                        rowData.isCompleted,
                                                        "1"
                                                      )
                                                    }
                                                    value={ReactSystemFunctions.translate(
                                                      this.ml,
                                                      460956,
                                                      "value",
                                                      this.defaultML
                                                    )}
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(114, 194, 64, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="489874"
                                                    id="489874"
                                                    value="[datafield:createdAt]"
                                                    formatter="date"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 600,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(155, 155, 155, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                                <HorizontalStack
                                                  key="310930"
                                                  id="310930"
                                                  direction="horizontal"
                                                  size={2}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="963940"
                                                    id="963940"
                                                    value="[datafield:cartNo]"
                                                    formatter="date"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 600,
                                                        fontSize: "12px",
                                                        color:
                                                          "rgba(155, 155, 155, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                                <Label
                                                  key="46902"
                                                  id="46902"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    46902,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <HorizontalStack
                                                  key="914713"
                                                  id="914713"
                                                  direction="horizontal"
                                                  size={12}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="848986"
                                                    id="848986"
                                                    value="[datafield:curAccCode]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(155, 155, 155, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="612360"
                                                    id="612360"
                                                    value="[datafield:customerName]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "15px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                                <Label
                                                  key="881593"
                                                  id="881593"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    881593,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <HorizontalStack
                                                  key="733903"
                                                  id="733903"
                                                  direction="horizontal"
                                                  size={12}
                                                  overflowX="auto"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                >
                                                  <Label
                                                    key="631503"
                                                    id="631503"
                                                    value="[datafield:salesPersonCode]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(155, 155, 155, 1)",
                                                        lineHeight: "20px",
                                                      } as any
                                                    }
                                                  ></Label>
                                                  <Label
                                                    key="26290"
                                                    id="26290"
                                                    value="[datafield:salesPersonName]"
                                                    writingMode="horizontal"
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        alignItems: "center",
                                                        textAlign:
                                                          "-webkit-left",
                                                        display: "inline",
                                                        fontFamily: "Poppins",
                                                        fontWeight: 400,
                                                        fontSize: "15px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  ></Label>
                                                </HorizontalStack>
                                              </VerticalStack>
                                            </KCol>
                                          </KRow>
                                          <KRow
                                            key="543142"
                                            id="543142"
                                            align="top"
                                            justify="start"
                                            horizontalGutter={0}
                                            verticalGutter={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "flex-start",
                                                textAlign: "-webkit-left",
                                              } as any
                                            }
                                          >
                                            <KCol
                                              key="621806"
                                              id="621806"
                                              xs={18}
                                              sm={18}
                                              md={18}
                                              lg={18}
                                              xl={18}
                                              xxl={18}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 0,
                                                  paddingRight: 8,
                                                  paddingBottom: 0,
                                                  paddingLeft: 8,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-center",
                                                } as any
                                              }
                                            >
                                              <VerticalStack
                                                key="792728"
                                                id="792728"
                                                direction="vertical"
                                                size={1}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 0,
                                                    paddingRight: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 0,
                                                    textAlign: "-webkit-left",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 400,
                                                    fontSize: "15px",
                                                    color:
                                                      "rgba(68, 68, 68, 1)",
                                                  } as any
                                                }
                                              >
                                                <Label
                                                  key="804990"
                                                  id="804990"
                                                  value={ReactSystemFunctions.translate(
                                                    this.ml,
                                                    804990,
                                                    "value",
                                                    this.defaultML
                                                  )}
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "14px",
                                                      color:
                                                        "rgba(155, 155, 155, 1)",
                                                      lineHeight: "20px",
                                                    } as any
                                                  }
                                                ></Label>
                                                <Label
                                                  key="23452"
                                                  id="23452"
                                                  value="[datafield:totalQuantity]"
                                                  writingMode="horizontal"
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 0,
                                                      paddingRight: 0,
                                                      paddingBottom: 0,
                                                      paddingLeft: 0,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                      display: "inline",
                                                      fontFamily: "Poppins",
                                                      fontWeight: 400,
                                                      fontSize: "15px",
                                                      color:
                                                        "rgba(68, 68, 68, 1)",
                                                    } as any
                                                  }
                                                ></Label>
                                              </VerticalStack>
                                            </KCol>
                                            <KCol
                                              key="922472"
                                              id="922472"
                                              xs={6}
                                              sm={6}
                                              md={6}
                                              lg={6}
                                              xl={6}
                                              xxl={6}
                                              order={0}
                                              pull={0}
                                              push={0}
                                              style={
                                                {
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  paddingTop: 8,
                                                  paddingRight: 8,
                                                  paddingBottom: 8,
                                                  paddingLeft: 8,
                                                  alignItems: "center",
                                                  textAlign: "-webkit-right",
                                                } as any
                                              }
                                            >
                                              <Icon
                                                key="28901"
                                                id="28901"
                                                onClick={(e?: any) => {
                                                  if (e && e.stopPropagation)
                                                    e.stopPropagation();
                                                  this.BasketReportsComponent_28901_onClick();
                                                }}
                                                showCursorPointer
                                                iconName="arrow_forward"
                                                iconLibrary="material"
                                                style={
                                                  {
                                                    borderTopLeftRadius: 8,
                                                    borderTopRightRadius: 8,
                                                    borderBottomRightRadius: 8,
                                                    borderBottomLeftRadius: 8,
                                                    borderTopWidth: 1,
                                                    borderRightWidth: 1,
                                                    borderBottomWidth: 1,
                                                    borderLeftWidth: 1,
                                                    borderColor:
                                                      "rgba(0, 0, 0, 1)",
                                                    borderStyle: "solid",
                                                    paddingTop: 4,
                                                    paddingRight: 4,
                                                    paddingBottom: 4,
                                                    paddingLeft: 4,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontSize: "24px",
                                                    color: "rgba(0, 0, 0, 1)",
                                                    letterSpacing: "1px",
                                                  } as any
                                                }
                                              ></Icon>
                                            </KCol>
                                          </KRow>
                                        </KTableColumn>
                                      </KTableRow>
                                    </KTable>
                                    <KPagination
                                      key="994572"
                                      id="994572"
                                      onChange={(e?: any) => {
                                        if (e && e.stopPropagation)
                                          e.stopPropagation();
                                        this.BasketReportsComponent_994572_onChange();
                                      }}
                                      kuikaRef={
                                        this
                                          .basketreports_994572_value_kuikaPaginationRef
                                      }
                                      total={
                                        this.state.CompletedBasket?.at?.(0)
                                          ?.totalRowCount ?? undefined
                                      }
                                      pageSize={10}
                                      defaultCurrent={1}
                                      current={1}
                                      defaultPageSize={10}
                                      disabled={false}
                                      hideOnSinglePage={true}
                                      showLessItems={false}
                                      showQuickJumper={false}
                                      showSizeChanger={false}
                                      showFirstPageButton={false}
                                      showLastPageButton={false}
                                      showNumbers={true}
                                      showText={false}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-right",
                                        } as any
                                      }
                                    ></KPagination>
                                  </KCol>
                                </KRow>
                              </KCol>
                            </KRow>
                          </KTabItem>
                        </KTab>
                      </Form.Item>
                    </KCol>
                  </KRow>
                </div>
              </>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(BasketReports_Screen)
        )
      )
    )
  )
);
export { tmp as BasketReports_Screen };
//export default tmp;
//export { tmp as BasketReports_Screen };
